import { render, staticRenderFns } from "./PodcastEpisode.vue?vue&type=template&id=5f9ad9fc&"
import script from "./PodcastEpisode.vue?vue&type=script&lang=js&"
export * from "./PodcastEpisode.vue?vue&type=script&lang=js&"
import style0 from "./PodcastEpisode.vue?vue&type=style&index=0&id=5f9ad9fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIBreadcrumb: require('/opt/build/repo/components/UI/Breadcrumb.vue').default})
